(function () {
  if (window.__kwStd) return; window.__kwStd = 1;
  var CH = '<svg viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="{P}"/></svg>';
  function ensure() {
    var cars = document.querySelectorAll('#qa-overlay .qa-carousel, #qa-overlay #qa-media-container, [id^="saw-qa-overlay-"] .saw-carousel, [id^="saw-inline-home-"] .saw-carousel');
    for (var i = 0; i < cars.length; i++) {
      (function (c) {
        var mcol = c.closest('.saw-inline-media');
        if (mcol && mcol.querySelector('[data-saw-qa-next]')) { c.setAttribute('data-kwnav', '1'); return; }   // panel has its own arrows
        if (c.getAttribute('data-kwnav')) { if (c._kwUpd) c._kwUpd(); return; }
        c.setAttribute('data-kwnav', '1');
        var w = document.createElement('div'); w.className = 'kwnav-wrap';
        c.parentNode.insertBefore(w, c); w.appendChild(c);
        [['kwnav-prev', '15 18 9 12 15 6', -1], ['kwnav-next', '9 18 15 12 9 6', 1]].forEach(function (b) {
          var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'kwnav-btn ' + b[0];
          btn.innerHTML = CH.replace('{P}', b[1]);
          btn.addEventListener('click', function (ev) { ev.stopPropagation(); ev.preventDefault(); c.scrollBy({ left: b[2] * Math.round(c.clientWidth * 0.9), behavior: 'smooth' }); });
          w.appendChild(btn);
        });
        var upd = function () { var mx = c.scrollWidth - c.clientWidth - 4; var pb = w.querySelector('.kwnav-prev'), nb = w.querySelector('.kwnav-next'); if (pb) pb.style.visibility = c.scrollLeft <= 4 ? 'hidden' : 'visible'; if (nb) nb.style.visibility = c.scrollLeft >= mx ? 'hidden' : 'visible'; };
        c._kwUpd = upd;
        c.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
        setTimeout(upd, 80);
      })(cars[i]);
    }
  }
  function fabSpecs() {
    var ov = document.querySelector('#qa-overlay.is-visible, [id^="saw-qa-overlay-"].is-visible, [id^="saw-inline-home-"].is-visible');
    if (!ov) return null;
    var sp = ov.querySelector('.kw-specs');
    return (sp && sp.style.display !== 'none' && sp.innerHTML) ? sp : null;
  }
  function fabHost() {
    var ov = document.querySelector('#qa-overlay.is-visible, [id^="saw-qa-overlay-"].is-visible, [id^="saw-inline-home-"].is-visible');
    if (!ov) return null;
    var w = ov.querySelector('.kwnav-wrap');
    if (w) return w;
    var c = ov.querySelector('#qa-media-container, .qa-carousel, .saw-carousel');
    if (!c) return null;
    var pe = c.parentElement;
    if (!pe.classList.contains('kw-fab-wrap') && !pe.classList.contains('kwnav-wrap')) {
      var d = document.createElement('div'); d.className = 'kw-fab-wrap';
      c.parentNode.insertBefore(d, c); d.appendChild(c); pe = d;
    }
    return pe;
  }
  /* Offer banner copy comes from section settings so each template can run its own offer.
     *text* marks the highlighted part (maroon on the headline, bold in the code line). */
  // this block is a page-global singleton — `root` from the section IIFE is NOT in scope here
  var offerRoot  = document.querySelector('[data-offer-main]');
  var OFFER_TOP  = (offerRoot && offerRoot.getAttribute('data-offer-top'))  || 'You Just Got an *Upgrade!*';
  var OFFER_MAIN = (offerRoot && offerRoot.getAttribute('data-offer-main')) || 'BUY 4, GET *₹1000 OFF*';
  var OFFER_SUB  = (offerRoot && offerRoot.getAttribute('data-offer-sub'))  || 'Use Code : *1000OFF* At Checkout';
  function offerEsc(t) {   // block-local: esc() lives in another <script> scope
    return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function offerMarkup(txt, tag) {
    var out = '', parts = String(txt || '').split('*');
    parts.forEach(function (chunk, i) {
      var safe = offerEsc(chunk);
      out += (i % 2 === 1) ? '<' + tag + '>' + safe + '</' + tag + '>' : safe;
    });
    return out;
  }
  function fabTick() {
    var fab = document.getElementById('kw-details-fab');
    if (!fab) {
      fab = document.createElement('button'); fab.type = 'button'; fab.id = 'kw-details-fab'; fab.className = 'kw-details-fab'; fab.textContent = 'Details';
      fab.addEventListener('click', function () { var sp = fabSpecs(); if (sp) sp.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
      document.body.appendChild(fab);
    }
    var show = false, host = fabHost();
    if (host) {
      var kwm = host.closest('.qa-modal, .saw-modal, .saw-inline') || host.parentElement;
      if (kwm) {
        var kwd = kwm.querySelector('.qa-progress-wrap, .saw-qa-progress-wrap');
        if (kwd && kwd.parentElement !== host) host.appendChild(kwd);
        var kwb = kwm.querySelector('.kw-b3g1');
        // Desktop: banner sits under the media column. Mobile: under the ADD TO BAG / BUY NOW row.
        var btnRow = kwm.querySelector('.saw-btn-row, .qa-btn-row');
        // offer mode: campaign3/4 pass copy via data-offer-* attrs; pack builders get PICK ANY 3; everyone else BUY 3 GET 1 FREE
        var kwRootEl = host.closest('.saw-root');
        var kwPack = !!(kwRootEl && kwRootEl.getAttribute('data-bucket') === 'true' && kwRootEl.getAttribute('data-bucket-free') === 'false');
        var kwMode = offerRoot ? 'attr' : (kwPack ? 'pack3' : 'b3g1');
        if (!kwb && btnRow) { btnRow.insertAdjacentHTML('afterend', '<div class="kw-b3g1"></div>'); kwb = kwm.querySelector('.kw-b3g1'); }
        if (kwb && kwb.getAttribute('data-offer-mode') !== kwMode) {
          kwb.setAttribute('data-offer-mode', kwMode);
          kwb.innerHTML = kwMode === 'attr'
            ? '<div class="kw-b3g1-top">' + offerMarkup(OFFER_TOP, 'em') + '</div><div class="kw-b3g1-main">' + offerMarkup(OFFER_MAIN, 'em') + '</div><div class="kw-b3g1-sub"><span></span>' + offerMarkup(OFFER_SUB, 'b') + '<span></span></div>'
            : kwMode === 'pack3'
            ? '<div class="kw-b3g1-top">Mix &amp; Match \u00b7 Any <em>3</em></div><div class="kw-b3g1-main">PACK OF 3 \u00b7 PICK ANY <em>3</em></div><div class="kw-b3g1-sub"><span></span>All 3 added to your bag together<span></span></div>'
            : '<div class="kw-b3g1-top">You Just Got an <em>Upgrade!</em></div><div class="kw-b3g1-main">BUY 3, GET 1 <em>FREE</em></div><div class="kw-b3g1-sub"><span></span>Automatically Applied at <b>Checkout.</b><span></span></div>';
        }
        if (kwb && btnRow && kwb.previousElementSibling !== btnRow) btnRow.parentNode.insertBefore(kwb, btnRow.nextSibling);   // always straight under ADD TO BAG / BUY NOW
        // maroon strip: inject on modals that don't ship their own, and pull the close button onto it
        // inject only into MODAL overlays — inline flex/grid panels (flowy family) break when a
        // child is prepended at runtime; those get their strip via Liquid markup instead
        var kwIsModal = kwm.classList.contains('saw-modal') || kwm.classList.contains('qa-modal');
        if (kwIsModal && !kwm.querySelector('[class*="saw-ov-strip"], .kwstd-strip')) {
          kwm.insertAdjacentHTML('afterbegin',
            '<div class="kwstd-strip"><div class="kwstd-rot" aria-hidden="true">'
            + '<span class="kwstd-msg kwstd-m1"><img class="kwstd-ico" src="' + window.__kwStdCfg.people + '" alt="" loading="lazy">Trusted by 8 Lakh+ Verified Customers</span>'
            + '<span class="kwstd-msg kwstd-m2"><img class="kwstd-ico" src="' + window.__kwStdCfg.pay + '" alt="" loading="lazy">Get Extra Discount At Checkout</span>'
            + '</div></div>');
        }
        var stdStrip = kwm.querySelector('.kwstd-strip');
        if (stdStrip) {
          var kwClose = kwm.querySelector('[data-saw-close-qa], [data-saw-close-inline], .saw-inline-close, .qa-close, .saw-close');
          if (kwClose && kwClose.parentElement !== stdStrip) { stdStrip.appendChild(kwClose); kwClose.classList.add('kwstd-close'); }
        }
        // All Linen order: colour row sits BELOW the price block
        var kwPrice = kwm.querySelector('.saw-qa-priceblock, .qa-priceblock');
        var kwCols = kwm.querySelector('.saw-qa-colors, .qa-colors');
        var kwColHead = kwm.querySelector('.saw-qa-colorhead, .qa-colorhead');
        if (kwPrice && kwCols && kwPrice.parentElement === kwCols.parentElement
            && (kwPrice.compareDocumentPosition(kwCols) & 2)) {   // 2 = colours currently precede the price
          if (kwColHead) kwPrice.after(kwColHead, kwCols); else kwPrice.after(kwCols);
        }
      }
    }
    if (window.innerWidth < 769) {
      var lb = document.getElementById('kw-lb'), slb = document.getElementById('saw-lb');
      var covered = !!document.querySelector('#sc-overlay.is-visible, [id^="saw-sc-overlay-"].is-visible, #filter-overlay.is-visible, [id^="saw-filter-overlay-"].is-visible') || (lb && lb.classList.contains('on')) || (slb && slb.classList.contains('on'));
      show = !!(host && fabSpecs() && !covered);
    }
    if (host && fab.parentElement !== host) host.appendChild(fab);
    fab.style.display = show ? 'flex' : 'none';
  }
  /* 2026-09-13: this 50KB file is only needed for OTHER products' charts inside the overview sheet —
     the product being viewed now carries its own chart inline. Deferred to the first sheet open so a
     shopper who never opens it never downloads it. */
  window.__kwSeedLoad = function () {
    if (window.__kwSeed) return; window.__kwSeed = 1;
    try { var g = (localStorage.getItem('saadaaKiwiSeedV') || '').split('|'); if (g[0] === 'v1' && Date.now() - (+g[1] || 0) < 432000000) return; } catch (e) {}
    fetch(window.__kwStdCfg.kiwi).then(function (r) { return r.json(); }).then(function (m) {
      var ts = Date.now();
      Object.keys(m).forEach(function (id) {
        try { if (m[id] && m[id].rows && !localStorage.getItem('saadaaKiwiC:' + id)) localStorage.setItem('saadaaKiwiC:' + id, JSON.stringify({ ts: ts, headers: m[id].headers, rows: m[id].rows })); } catch (e) {}
      });
      try { localStorage.setItem('saadaaKiwiSeedV', 'v1|' + Date.now()); } catch (e) {}
      if (window.saadaaHydrateOverlayKiwi) { try { saadaaHydrateOverlayKiwi(); } catch (e) {} }
      if (window.__kwSeedDone) { try { window.__kwSeedDone(); } catch (e) {} }
    }).catch(function () {});
  };
  /* Any tap that can open an overview / size sheet pulls the seed, once. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.kwstd-fab, .saw-ov-open, .ks-open-btn, .saadaa-ks-open-btn, [data-kw-overview]')) {
      try { window.__kwSeedLoad(); } catch (x) {}
    }
  }, true);
  function kwnavCenter() {
    var ws = document.querySelectorAll('.kwnav-wrap');
    for (var i = 0; i < ws.length; i++) {
      var img = ws[i].querySelector('img');
      if (img && img.clientHeight) {
        var t = Math.round(img.offsetTop + img.clientHeight / 2) + 'px';
        var bs = ws[i].querySelectorAll('.kwnav-btn');
        for (var j = 0; j < bs.length; j++) bs[j].style.top = t;
      }
    }
  }
  function kwSyncNow() { try { ensure(); kwnavCenter(); fabTick(); } catch (e) {} }
  window.__sawKwSync = kwSyncNow;   // openQuickAdd calls this so the modal isn't half-built for ~900ms
  setInterval(kwSyncNow, 400);
  if (document.readyState !== 'loading') ensure(); else document.addEventListener('DOMContentLoaded', ensure);
  var TOAST_HTML = '<div class="cart-toast-content"><svg class="checkmark-svg" viewBox="0 0 52 52"><circle class="checkmark-circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg><div class="cart-toast-text"><span id="kw-toast-text">Added to bag</span><span class="cart-toast-sub" id="kw-toast-sub" style="display:none;"></span></div></div>';
  window.kwToast = function (text, sub) {
    var t = document.getElementById('kw-toast');
    if (!t) { t = document.createElement('div'); t.id = 'kw-toast'; t.className = 'kw-toast'; t.innerHTML = TOAST_HTML; document.body.appendChild(t); }
    var tx = document.getElementById('kw-toast-text'), sb = document.getElementById('kw-toast-sub');
    if (tx) tx.innerText = text || 'Added to bag';
    if (sb) { if (sub) { sb.innerText = sub; sb.style.display = 'block'; } else sb.style.display = 'none'; }
    t.classList.remove('show-toast'); void t.offsetWidth;
    t.classList.add('show-toast');
    clearTimeout(t._kwT); t._kwT = setTimeout(function () { t.classList.remove('show-toast'); }, sub ? 2200 : 1500);
  };
  window.kwRate = function (el, r, n) {
    if (!el) return;
    var m = el.closest('.qa-modal, .saw-modal');
    var title = m && m.querySelector('.qa-title, .saw-qa-title');
    if (title && title.parentElement && !title.parentElement.classList.contains('kw-title-row')) {
      var row = document.createElement('div'); row.className = 'kw-title-row';
      title.parentNode.insertBefore(row, title); row.appendChild(title); row.appendChild(el);
    }
    var v = parseFloat(r);
    if (!v) { el.style.display = 'none'; el.innerHTML = ''; return; }
    el.innerHTML = v.toFixed(1) + ' <svg viewBox="0 0 24 24" width="13" height="13" fill="#f5a623" aria-hidden="true"><path d="M12 17.3l-6.18 3.73 1.64-7.03L2 9.24l7.19-.61L12 2l2.81 6.63 7.19.61-5.46 4.76 1.64 7.03z"/></svg>';
    el.style.display = 'flex';
  };
  window.kwSizeLabel = function (scope, h) {
    try {
      if (h && h.headers) h = h.headers[0];
      h = String(h || '').toUpperCase().replace(/\s+/g, ' ').trim();
      if (!h || /LENGTH|INSEAM|SIZE/.test(h)) return;
      var el = (scope && scope.querySelector ? scope : document).querySelector('.kw-size-lbl');
      if (el) el.textContent = 'YOUR ' + h + ' SIZE:';
    } catch (e) {}
  };
  window.kwSpecs = function (el, ref) {
    if (!el) return;
    var rows = '';
    if (ref) {
      for (var i = 1; i <= 6; i++) {
        var k = ref['k' + i] && ref['k' + i].value, v = ref['v' + i] && ref['v' + i].value;
        if (k && v) rows += '<div><span class="kw-specs-k">' + k + '</span><span class="kw-specs-v">' + v + '</span></div>';
      }
    }
    if (!rows) { el.style.display = 'none'; el.innerHTML = ''; return; }
    el.innerHTML = '<div class="kw-specs-title">Key Highlights</div><div class="kw-specs-grid">' + rows + '</div>';
    el.style.display = 'block';
  };
})();
